<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<template>
  <div>
    <transactions
      :isCurrentUser="!this.$route.query.shopName"
      @initFilters="initFilters"
      @getData="getdata"
    >
      <template v-slot:title>
        <div class="vx-row mb-2">
          <h3>
            تراکنش های تسویه "{{ $moment($route.query.settlementDate).format('jYYYY/jM/jD') }}"
            <template v-if="$route.query.shopName">
              پذیرنده "{{ $route.query.shopName }}"
            </template>
          </h3>
          <div class="vx-col w-full">
            <vs-button
              class="mr-3 mb-2"
              @click="$router.go(-1)"
              type="flat"
              icon-pack="feather"
              icon="icon-chevron-right"
              >بازگشت</vs-button
            >
          </div>
        </div>
      </template>
    </transactions>
  </div>
</template>
<style>
</style>
<script>
import Transactions from "./Transactions.vue";
export default {
  components: {
    Transactions,
  },
  data() {
    return {
      SettlementId: null,
      shopName: "",
    };
  },
  methods: {
    initFilters() {
      if (Object.keys(this.$route.query).length != 0) {
        this.SettlementId = this.$route.query.sett || this.SettlementId;
      }
    },
    getdata(e) {
      e.payload.params.SettlementId = this.SettlementId;
      e.payload.params.OnlySource = false;
      e.query.sett = this.SettlementId;
      e.query.shopName = this.$route.query.shopName;
      e.query.settlementDate = this.$route.query.settlementDate;
    },
  },
};
</script>
